<template>
  <el-dialog
    class="dialog"
    v-model="show"
    :fullscreen="fullscreen"
    :width="width"
    :show-close="false"
    :close-on-click-modal="false"
    v-bind="$attrs"
  >
    <template #header v-if="showHeader">
      <div class="title">
        <div class="title-text">{{ title }}</div>
        <span @click="close('icon')" v-if="showClose" class="pointer icon iconfont icon-close" />
      </div>
    </template>
    <slot />
    <template #footer v-if="showFooter">
      <slot name="footer">
        <div class="footer">
          <slot name="footerLeft" />
          <div style="flex: 1">
            <RxkButton @click="close('btn')" v-if="showCancelBtn">{{ cancelBtn }}</RxkButton>
            <RxkButton
              :isLoading="isLoading"
              type="primary"
              @click="sure"
              ref="btnRef"
              :disabled="disableConfirm"
              v-if="showConfirmBtn"
            >
              {{ confirmBtn }}
            </RxkButton>
          </div>
        </div>
      </slot>
    </template>
  </el-dialog>
</template>
<script setup lang="ts">
// @todo
import { computed, ref } from 'vue'
import { RxkButton } from '@/components/common/RxkButton'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: '标题'
  },
  showFooter: {
    type: Boolean,
    default: true
  },
  showHeader: {
    type: Boolean,
    default: true
  },
  fullscreen: {
    type: Boolean,
    default: false
  },
  width: {
    type: [String, Number],
    default: '200px'
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  showCancelBtn: {
    type: Boolean,
    default: true
  },
  cancelBtn: {
    type: String,
    default: '取消'
  },
  showConfirmBtn: {
    type: Boolean,
    default: true
  },
  confirmBtn: {
    type: String,
    default: '确定'
  },
  showClose: {
    type: Boolean,
    default: true
  },
  // 是否禁用确认按钮-使用场景在协议弹窗，当读完协议才让其点击
  disableConfirm: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'sure', 'close'])
const loading = ref(false)
const btnRef = ref()
const show = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    emit('update:modelValue', val)
  }
})
function close(type: 'icon' | 'btn') {
  emit('update:modelValue', false)
  emit('close', type)
}
function sure(fn: Fn) {
  if (props.isLoading) {
    loading.value = true
    emit('sure', () => {
      loading.value = false
      fn?.()
    })
  } else {
    emit('sure')
  }
}
function showLoading(val: boolean) {
  btnRef.value.loading = val
}
defineExpose({
  showLoading
})
</script>
<style lang="scss">
.dialog {
  .el-dialog__header {
    padding: 0;
    margin: 0;
  }

  .el-dialog__footer {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
    height: 100%;
    max-height: 600px;
    overflow-y: auto;
  }
}
</style>
<style lang="scss" scoped>
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  padding: 0 24px;
  border-bottom: 1px solid #ebeef5;

  .title-text {
    font-size: 14px;
    font-weight: 700;
    color: #333;
  }

  span {
    font-size: 16px;
    color: #999999;
  }
}

.footer {
  height: 64px;
  line-height: 64px;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
